<template>
<div>
    <div>
        <h3>Investigation</h3>
    </div>
    <tabs nav-style="tabs" v-model="activeTabIndex">
        <tab header="Investigation Summary">
            <projectHeader v-bind:project="project" />
            <investigationHeader v-show="investigation" v-bind:investigation="investigation" :invMigrationRefs="invMigrationRefs"></investigationHeader>
            <undertakingHeader v-show="investigation && !isConsultantOnly" v-bind:undertaking="undertaking"></undertakingHeader>
            <loader v-if="investigationLoading" />
            <div v-if="isShpo && isPendingQaqc">
                <div style="margin-left: 20px;">
                    <label class="control-label text-label" for="isBacklog">Back Log</label>
                    <input type="checkbox" v-model="isBacklogSelect" class="form-check-input" id="isBacklog" style="width: 15px; height: 15px;"/>
                    <button name="buttonBacklog" class="btn" style="width:100px;" @click="saveBacklog">Save</button>
                </div>
            </div>
            <fieldset :disabled="formDisabled">
                <form class="form-horizontal" @submit.prevent="submitInvestigation" data-vv-scope="investigation">
                    <div class="form-group" v-if="!formDisabled && investigationId">
                        <div class="sectionHeaderRight">
                            <router-link :to="{ path: '/SiteNumberRequest', query: { projectId: project.projectId, investigationId: investigationId }}" tag="button" class="btn btn-primary btn-block">Site Number Request</router-link>
                        </div>
                    </div>
                    <div class="form-group" v-bind:class="{ 'has-error': errors.has('investigation.reportTitle') }">
                        <label class="col-md-2 control-label">Report Title</label>
                        <div class="col-md-10">
                            <textarea name="reportTitle" class="form-control" v-model="investigation.reportTitle" placeholder="Report Title" v-validate="'required|max:255'" aria-required="true"></textarea>
                            <span v-show="errors.has('investigation.reportTitle')" class="has-error">
                                {{ reportTitleErrorMsg }}
                            </span>
                            <span style="font-size:11px; float:right;">{{ (investigation.reportTitle || '').length + '/255' }}</span>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-2 control-label">Activities</label>
                        <div class="col-md-10">
                            <checkBoxPanel :numColumns="4" :lookupList="investigationActivities" ref='activitiesCheckboxPanel' :fieldName="'activityTypeId'" name="investigationActivitiesCB" />
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-2 control-label">Survey Scope</label>
                        <div class="col-md-4">
                            <select name="surveyScopeId" class="form-control" v-model="investigation.surveyScopeId">
                                <option value="">Select a value</option>
                                <option v-for="surveyScope in surveyScopeList" v-bind:value="surveyScope.surveyScopeId" :key="surveyScope.surveyScopeId">
                                    {{ surveyScope.description}}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="form-group" v-bind:class="{ 'has-error': errors.has('investigation.fieldworkStartDate') || errors.has('investigation.fieldworkEndDate') }">
                        <label class="col-md-2 control-label">Field Work Dates</label>
                        <div class="col-md-8">
                            <el-date-picker v-model="investigation.fieldworkStartDate" type="date" format="MM/dd/yyyy" placeholder="Select Start Date" :disabled="formDisabled"></el-date-picker>
                            <input name="fieldworkStartDate" type="hidden" v-model="investigation.fieldworkStartDate" v-validate="'required'" />
                            <label>&nbsp; TO &nbsp; </label>
                            <el-date-picker v-model="investigation.fieldworkEndDate" type="date" format="MM/dd/yyyy" placeholder="Select End Date" :disabled="formDisabled"></el-date-picker>
                            <input name="fieldworkEndDate" type="hidden" v-model="investigation.fieldworkEndDate" v-validate="'required'" />
                            <div><span v-show="errors.has('investigation.fieldworkStartDate')" class="has-error">Fieldwork Start Date is required</span></div>
                            <div><span v-show="errors.has('investigation.fieldworkEndDate')" class="has-error">Fieldwork End Date is required</span></div>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-2 control-label">Summary Results</label>
                        <div class="col-md-4">
                            <textarea name="resultSummary" class="form-control" v-model="investigation.resultSummary" placeholder="Summary Results" ></textarea>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-2 control-label">Type of Sites Reported</label>
                        <div class="col-md-4 text-label">
                            {{investigation.propertyTypes}}
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-2 control-label text-label">Site Count</label>
                        <div class="col-md-6 text-label">
                            {{siteCount}}
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-2 control-label text-label">Isolated Resource Count</label>
                        <div class="col-md-6 text-label">
                            {{isolateCount}}
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-2 control-label">Crew Chief(s)</label>
                        <div class="col-md-4">
                            <input type="text" v-model="investigation.crewCheifs" class="form-control">
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-2 control-label">Crew Members</label>
                        <div class="col-md-4">
                            <textarea class="form-control" v-model="investigation.crewMembers" placeholder="Crew Members"></textarea>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-2 control-label">Author</label>
                        <div class="col-md-4">
                            <input type="text" v-model="investigation.reportAuthor" class="form-control">
                        </div>
                    </div>
                    <div class="form-group" v-if="!beforeDateConversion">
                        <landOwnership :parentId="investigationId" source='Investigation' :formDisabled="formDisabled" />
                    </div>
                    <div class="form-group" v-if="beforeDateConversion">
                        <label class="col-md-2 control-label">Investigation Area (in whole acres)</label>
                        <div class="col-md-8">
                            <table border="0">
                            <tr>
                                <td style="width: 75px;"></td>
                                <td style="text-align: center;">Intensive/Class III</td>
                                <td style="text-align: center;">Extensive/Other</td>
                                <td style="text-align: center;">Total</td>
                            </tr>
                            <tr>
                                <td>Federal</td>
                                <td style="width: 125px;"><input type="number" min="0" step=".1" class="form-control" v-model.number="investigation.acresFederalIntensive"></td>
                                <td style="width: 125px;"><input type="number" min="0" step=".1" class="form-control" v-model.number="investigation.acresFederalExtensive"></td>
                                <td style="text-align: center;">{{ addValues([investigation.acresFederalIntensive, investigation.acresFederalExtensive]) }}</td>
                            </tr>
                            <tr>
                                <td>Other Public</td>
                                <td><input type="number" min="0" step=".1" class="form-control" v-model.number="investigation.acresOtherPublicIntensive"></td>
                                <td><input type="number" min="0" step=".1" class="form-control" v-model.number="investigation.acresOtherPublicExtensive"></td>
                                <td style="text-align: center;">{{ addValues([investigation.acresOtherPublicIntensive, investigation.acresOtherPublicExtensive]) }}</td>
                            </tr>
                            <tr>
                                <td>Private</td>
                                <td><input type="number" min="0" step=".1" class="form-control" v-model.number="investigation.acresPrivateIntensive"></td>
                                <td><input type="number" min="0" step=".1" class="form-control" v-model.number="investigation.acresPrivateExtensive"></td>
                                <td style="text-align: center;">{{ addValues([investigation.acresPrivateIntensive, investigation.acresPrivateExtensive]) }}</td>
                            </tr>
                            <tr>
                                <td style="height: 25px;">Total</td>
                                <td style="text-align: center;">{{ addValues([investigation.acresFederalIntensive, investigation.acresOtherPublicIntensive, investigation.acresPrivateIntensive]) }}</td>
                                <td style="text-align: center;">{{ addValues([investigation.acresFederalExtensive, investigation.acresOtherPublicExtensive, investigation.acresPrivateExtensive]) }}</td>
                                <td style="text-align: center;"></td>
                            </tr>
                            </table>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-2 control-label">PLSS Location</label>
                        <div class="col-md-4" v-if="!formDisabled">
                            <button name="button3" class="btn btn-primary" :disabled="!investigation.investigationId" v-on:click="$refs['plssLocationModal'].open()">Add PLSS Locations</button>
                            <modal title="Add Sections(s)" ref="plssLocationModal">
                                <div slot="header">
                                    <h4>Add PLSS Locations</h4>
                                </div>
                                <div slot="body">
                                    <plssComponent v-on:savePlss="savePlss" ref="plssComponent" :showTitle="false" />
                                </div>
                                <div slot="footer">
                                    <div>
                                        <button type="button" class="btn btn-primary col-md-3" v-on:click="$refs['plssLocationModal'].close()">Close</button>
                                    </div>
                                </div>
                            </modal>
                        </div>
                    </div>
                    <div class="form-group">
                        <label class="col-md-2 control-label">Section List</label>
                        <div class="col-md-8">
                            <v-client-table :data="plssLocationGridSpec.tableData" :columns="plssLocationGridSpec.columns" :options="plssLocationGridSpec.options">
                                <template slot="delete" slot-scope="props" v-if="!formDisabled">
                                    <div style="text-align: center;">
                                        <a class="fa fa-ban" style="font-size: 18px;" v-on:click="deletePlssLocation(props.row.investigationPlssLocationId)"></a>
                                    </div>
                                </template>
                            </v-client-table>
                        </div>
                    </div>

                    <div class="form-group">
                        <div class="col-md-2"></div>
                        <div class="col-md-8">
                            <div v-show="serverErrorList.length > 0">
                                <span class="has-error">Validation issues must be corrected prior to submit</span>
                                <ul class="has-error">
                                    <li v-for="serverError in serverErrorList" :key="serverError.index">{{ serverError }}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-offset-2" v-if="!formDisabled">
                            <button :disabled="saving || isLoading" name="buttonSubmit" class="btn btn-primary btn-block" type="submit" style="width:100px;">
                                {{isNew ? 'Create' : 'Save'}}
                            </button>
                        </div>
                    </div>
                </form>
            </fieldset>
            <br />
            <div v-show="isDebug" style="margin-top: 20px;">
                <div>
                    <h3 class="text-danger">****** Debug ******</h3>
                </div>
                <div>
                    <h4>Investigation: </h4>
                    <pre>{{ investigation }}</pre>

                    <h4> Error: </h4>
                    <pre>{{serverErrorList}}</pre>
                </div>
            </div>
        </tab>
        <tab header="Documents" :disabled="isNew" v-if="!isClientUser">
            <projectHeader v-bind:project="project" />
            <investigationHeader v-show="investigation" v-bind:investigation="investigation"></investigationHeader>
            <undertakingHeader v-show="investigation && !isConsultantOnly" v-bind:undertaking="undertaking"></undertakingHeader>
            <div style="margin-top: 20px;">
                <investigationDocuments v-if="!isNew" :parentId="investigationId" :formDisabled="formDisabled && !shpoCrHasDoc" :loadOnMount="false" :isAdmin="isAdmin" ref="documents"
                 v-on:mediaRefreshComplete="handleMediaRefreshComplete()" :documentPermissions="documentPermissions" />
            </div>
            <div style="margin-top: 20px;">
                <hr />
                <mediaLetter v-if="!isNew" :parentId="investigationId" :mediaTypeId="letterMediaTypeId" :loadOnMount="false" ref="mediaLetter"></mediaLetter>
                <scantoolMedia v-if="!isNew" :investigationId="investigationId" :loadOnMount="false" ref="scantoolMedia"></scantoolMedia>
            </div>
        </tab>
        <tab header="Map" :disabled="isNew || isLoading" v-if="!isClientUser && !isRestrictedRole">
            <projectHeader v-bind:project="project" />
            <investigationHeader v-show="investigation" v-bind:investigation="investigation"></investigationHeader>
            <undertakingHeader v-show="investigation && !isConsultantOnly" v-bind:undertaking="undertaking"></undertakingHeader>
           <mapx v-if="!isLoading" :mediaTypeId="mediaTypeId" :parentId="investigationId" :loadOnMount="false" :invDbNumber="invMapUseDbi" ref="mapx"></mapx>
        </tab>
        <tab header="Cultural Resource Selection" :disabled="isNew" v-if="!isClientUser && !isRestrictedRole">
            <projectHeader v-bind:project="project" />
            <investigationHeader v-show="investigation" v-bind:investigation="investigation"></investigationHeader>
            <undertakingHeader v-show="investigation && !isConsultantOnly" v-bind:undertaking="undertaking"></undertakingHeader>
            <culturalResourceSelection v-bind:investigation="investigation" :formDisabled="formDisabled" :isQaqc="isPendingQaqc" :loadOnMount="false" ref="crSelection"/>
        </tab>
        <tab header="Site Summary / Submission" :disabled="isNew">
            <projectHeader v-bind:project="project" />
            <investigationHeader v-show="investigation" v-bind:investigation="investigation"></investigationHeader>
            <undertakingHeader v-show="investigation && !isConsultantOnly" v-bind:undertaking="undertaking"></undertakingHeader>
            <siteSummary id="siteSummary" :isClientUser="isClientUser" :investigation="investigation" :loadOnMount="isRestrictedRole" ref="siteSummary" :isConsultantOnly="isConsultantOnly"
                :isAdmin="isAdmin" v-on:workflowOnSubmitSuccess="workflowOnSubmitSuccess"></siteSummary>
            <div class="form-group">
                <quickLetter v-if="isShpo" :projectId="project.projectId" :investigationId="investigation.investigationId"
                :parentId="investigationId" :mediaTypeId="letterMediaTypeId"></quickLetter>
            </div>
            <div v-if="investigation.investigationId && !isClientUser">
                <button :disabled="reportLoading" name="invSummaryReport" class="btn btn-primary" v-on:click="genInvSummaryReport">Generate Summary Report</button>
                <button :disabled="reportLoading" name="invCoverReport" class="btn btn-primary" v-on:click="genInvSummaryCoverReport">Generate Cover Report</button>
            </div>
        </tab>
    </tabs>
</div>
</template>

<script>
import loggingService from '../services/util/loggingService'
import projectService from '../services/projectService'
import undertakingService from '../services/undertakingService'
//import culturalResourceRecordingService from '../services/culturalResourceRecordingService'
import surveyScopeService from '../services/surveyScopeService'
import siteTypeService from '../services/lookup/siteTypeService'
import investigationService from '../services/investigationService'
import mediaService from '../services/mediaService'
import roleService from '@/services/roleService.js'
import userService from '@/services/userService.js'
import gisService from '@/services/gisService'
import workflowService from '@/services/workflowService'
import { mapState } from 'vuex'

import projectHeader from '../components/ProjectHeader.vue'
import investigationHeader from '@/components/InvestigationHeader.vue'
import undertakingHeader from '@/components/UndertakingHeader.vue'
import checkBoxPanel from '../components/CheckBoxPanel.vue'
import loader from '../components/Loader.vue'
import culturalResourceSelection from './CulturalResourceSelection.vue'
import siteSummary from '@/components/SiteSummary.vue'
import investigationDocuments from '../components/InvestigationDocuments.vue'
import mediaLetter from '../components/MediaLetter.vue'
import scantoolMedia from '../components/ScantoolMedia.vue'
import quickLetter from '../components/QuickLetter.vue'
import mapx from '@/views/MapNew'
import modal from '@/components/Modal.vue'
import plssComponent from '../components/PlssComponent'
import landOwnership from '../components/LandOwnership'

import { tab, tabs } from 'vue-strap'

export default {
    components: {
        projectHeader,
        investigationHeader,
        undertakingHeader,
        loader,
        tabs,
        tab,
        culturalResourceSelection,
        checkBoxPanel,
        siteSummary,
        investigationDocuments,
        mapx,
        quickLetter,
        mediaLetter,
        modal,
        plssComponent,
        landOwnership,
        scantoolMedia
    },
    data: function () {
        return {
            isDebug: false,
            saving: false,
            investigationLoading: true,
            project: {},
            investigation: {},
            undertaking: {},
            surveyScopeList: [],
            serverErrorList: [],
            activeTabIndex: 0,
            investigationActivities: [],
            siteCount: 'None yet selected',
            isolateCount: 'None',
            mediaTypeId: mediaService.mediaType.InvestigationShapeFiles.toString(),
            letterMediaTypeId: mediaService.mediaType.InvestigationLetter,
            // create Enum for each tab on the page, also keep track if the tab has been clicked and loaded
            tabsEnum: {
                summary: 0,
                documents: 1,
                documentsLoaded: false,
                map: 2,
                mapLoaded: false,
                crSelection: 3,
                crSelectionLoaded: false,
                siteSummary: 4
            },
            plssLocationGridSpec: {
                columns: ['meridianDescription', 'locationDescription', 'section', 'delete'],
                tableData: [],
                options: {
                    perPage: 10,
                    perPageValues: [10, 25, 50, 100],
                    headings: {
                        meridianDescription: 'Meridian',
                        locationDescription: 'Township',
                        section: 'Section',
                        delete: 'Delete'
                    },
                    filterable: false
                }
            },
            reportLoading: false,
            invMigrationRefs: [],
            invWfsEnum: workflowService.InvestigationWorkflowStatusEnum,
            isLoading: false,
            isBacklogSelect: false
        }
    },
    computed: {
        isNew: function () {
            return (!this.investigation || !this.investigation.investigationId)
        },
        investigationId: function () {
            return (this.$route.params.investigationId || this.investigation.investigationId)
        },
        // compute current user info
        ...mapState({
            shpoUserDto: state => (state.auth.shpoUserDto || {})
        }),
        // disable forms if user is not admin or if agency/shpo didn't create it
        formDisabled: function () {
            return !(this.isAdmin || this.agencyCanEdit || this.consultantCanEdit || this.shpoCanEdit) ||
                this.isRestrictedRole || this.isClientUser
        },
        documentPermissions: function () {
            //if (!this.isSubmitted) return ['All']
            if (this.isAdmin) {
                return ['All']
            } else if (!this.agencyCanEdit && this.isAgency) {
                return ['Supporting Documents', 'Correspondence']
            } else if (!this.consultantCanEdit && this.isConsultantOnly) {
                return ['Radiocarbon Reports']
            } else if (this.shpoCrHasDoc) {
                return ['All']
            } else if (this.formDisabled) {
                return ['None']
            } else {
                return ['All']
            }
        },
        // hasAgencyAccess: function () {
        //     return (userService.hasRoleCheck(this.shpoUserDto.roleList, [roleService.RoleEnum.BlmUser])) &&
        //         (this.isNew || this.investigation.recordCreatedBy === 'Agency')
        // },
        // hasShpoAccess: function () {
        //     return this.isShpo && (this.isNew || (this.investigation.recordCreatedBy === 'SHPO'))
        // },
        isAdmin: function () {
            var roleList = [roleService.RoleEnum.Administrator, roleService.RoleEnum.ShpoAdministrator]
            return (this.shpoUserDto && userService.hasRoleCheck(this.shpoUserDto.roleList, roleList))
        },
        isShpo: function () {
            return (this.shpoUserDto && userService.hasRoleCheck(this.shpoUserDto.roleList, roleService.ShpoRoleList))
        },
        isAgency: function () {
            return (this.shpoUserDto && userService.hasRoleCheck(this.shpoUserDto.roleList, [roleService.RoleEnum.BlmUser]))
        },
        isRestrictedRole: function () {
            return userService.hasRoleCheck(this.shpoUserDto.roleList, roleService.RestrictedRoleList)
        },
        isConsultant: function () {
            var roleList = [roleService.RoleEnum.ConsultantUser, roleService.RoleEnum.CLGConsultant, roleService.RoleEnum.E106User, roleService.RoleEnum.ClientUser]
            if (this.investigation.recordCreatedBy === 'SHPO') roleList = roleList.concat(roleService.ShpoRoleList)
            if (this.investigation.recordCreatedBy === 'Agency') roleList.push(roleService.RoleEnum.BlmUser)
            return (this.shpoUserDto && userService.hasRoleCheck(this.shpoUserDto.roleList, roleList))
        },
        isConsultantOnly: function () {
            return this.isConsultant && !this.isAgency && !this.isShpo
        },
        isClientUser: function () {
            return (this.shpoUserDto && userService.hasRoleCheck(this.shpoUserDto.roleList, [roleService.RoleEnum.ClientUser]))
        },
        agencyCanEdit: function () {
            return this.isAgency && (this.investigation && (this.investigation.currentWorkflowStatusId <= this.invWfsEnum.PendingAgencyApproval))
        },
        shpoCanEdit: function () {
            if (this.isShpo) {
                if (this.isShpoReadOnly) {
                    return this.shpoCrBacklog
                } else {
                    return (this.investigation && (this.investigation.isE106Investigation || this.investigation.recordCreatedBy === 'SHPO'))
                }
            } else {
                return false
            }
        },
        isShpoReadOnly: function () {
            return userService.hasRoleCheck(this.shpoUserDto.roleList, roleService.ShpoReadOnlyRoleList)
        },
        consultantCanEdit: function () {
            return !this.isShpoReadOnly && (this.isNew || !this.isSubmitted)
        },
        isSubmitted: function () {
            return (this.investigation && this.investigation.currentWorkflowStatusId > this.invWfsEnum.PendingDataEntry)
        },
        isPendingQaqc: function () {
            return (this.investigation && this.investigation.currentWorkflowStatusId === this.invWfsEnum.PendingQaqc) //pending qaqc
        },
        shpoCrHasDoc: function () {
            return this.isShpoReadOnly && this.isPendingQaqc
        },
        shpoCrBacklog: function () {
            return this.isShpoReadOnly && this.investigation.isQaqcBacklog
        },
        beforeDateConversion: function () {
            //date the system switched over from entering acres to entering land ownership. Set to August 15th, 2019
            return new Date(this.investigation.createdDate) < new Date('2019-08-15T00:00:00')
        },
        invMapUseDbi: function () {
            if (this.investigation.currentWorkflowStatusId === this.invWfsEnum.Approved &&
                this.investigation.investigationTypeList.some(x => x.investigationTypeId === 3)) {
                return this.investigation.dbNumber
            } else {
                return null
            }
        },
        reportTitleErrorMsg: function () {
            if (!this.investigation.reportTitle) return 'Report Title is required.'
            if (this.investigation.reportTitle.length > 255) return 'Report Title may not be greater than 255 characters.'
            return 'Report Title error'
        }
    },
    watch: {
        activeTabIndex: function (val) {
            loggingService.log(this.isDebug, 'Investigation', 'watch.activeTabIndex: ' + val)
            switch (val) {
            case this.tabsEnum.summary: //Request
                break
            case this.tabsEnum.documents:
                if (!this.tabsEnum.documentsLoaded && this.$refs.documents) {
                    this.$refs.documents.loadData()
                    this.$refs.mediaLetter.loadMedia()
                    this.$refs.scantoolMedia.loadMedia()
                }
                this.tabsEnum.documentsLoaded = true
                break
            case this.tabsEnum.map:
                if (!this.tabsEnum.mapLoaded && this.$refs.mapx) this.$refs.mapx.createMap()
                this.tabsEnum.mapLoaded = true
                break
            case this.tabsEnum.crSelection:
                if (!this.tabsEnum.crSelectionLoaded && this.$refs.crSelection) this.$refs.crSelection.loadData()
                this.tabsEnum.crSelectionLoaded = true
                break
            case this.tabsEnum.siteSummary:
                this.$refs.siteSummary.loadData()
                break
            }
        }
    },
    created () {
        this.investigationActivities = [
            {activityTypeId: 1, description: 'Lit. Review (file search)'},
            {activityTypeId: 2, description: 'Class II Survey'},
            {activityTypeId: 3, description: 'Class III Survey'},
            {activityTypeId: 4, description: 'Visual Contrast Rating'},
            {activityTypeId: 5, description: 'Discovery'},
            {activityTypeId: 6, description: 'NR or Condition Assessment'},
            {activityTypeId: 7, description: 'Monitor / Trench Inspection'},
            {activityTypeId: 8, description: 'Testing'},
            {activityTypeId: 9, description: 'Data Recovery Plan'},
            {activityTypeId: 10, description: 'Data Recovery Action (excavation, mitigation)'},
            {activityTypeId: 11, description: 'Research Design'},
            {activityTypeId: 12, description: 'Overview (incl Class I)'},
            {activityTypeId: 13, description: 'Recon. Survey'},
            {activityTypeId: 14, description: 'EO 14156'}
        ]

        if (this.isRestrictedRole) {
            this.tabsEnum = {
                summary: 0,
                documents: 1,
                documentsLoaded: false,
                map: -1,
                mapLoaded: false,
                crSelection: -2,
                crSelectionLoaded: false,
                siteSummary: 2
            }
        }
        if (this.isClientUser) {
            this.tabsEnum = {
                summary: 0,
                documents: -1,
                documentsLoaded: false,
                map: -2,
                mapLoaded: false,
                crSelection: -3,
                crSelectionLoaded: false,
                siteSummary: 1
            }
        }
    },
    mounted () {
        loggingService.log(this.isDebug, 'Investigation', 'mounted for projectId ' + this.$route.query.projectId)
        Promise.all([this.loadLookups(), this.loadData()]).then(response => {
            loggingService.log(this.isDebug, 'Investigation', 'Done with all loading')
            this.investigationLoading = false
        })
    },
    methods: {
        loadSiteType () {
            return siteTypeService.listLookup(this.$http).then(response => {
                this.siteTypeList = response.data
                loggingService.log(this.isDebug, 'Investigation', 'loaded site type')
                return response
            })
        },
        loadSurveyScope () {
            return surveyScopeService.listLookup(this.$http).then(response => {
                this.surveyScopeList = response.data
                loggingService.log(this.isDebug, 'Investigation', 'loaded survey scope')
                return response
            })
        },
        loadLookups () {
            return Promise.all([this.loadSiteType(), this.loadSurveyScope()])
        },
        loadData () {
            this.isLoading = true
            loggingService.log(this.isDebug, 'Investigation', `loading data investigation:${this.$route.params.investigationId} project: ${this.$route.query.projectId}`)
            if (this.$route.params.investigationId) {
                return investigationService.get(this.$http, this.$route.params.investigationId).then(response => {
                    this.investigation = response.data
                    this.isBacklogSelect = this.investigation.isBacklog
                    this.$refs['activitiesCheckboxPanel'].selectedList = this.investigation.investigationTypeList.map(x => {
                        return x.investigationTypeId
                    })
                    if (this.investigation.projectId) {
                        projectService.search(this.$http, { projectId: this.investigation.projectId }).then(response => {
                            this.project = response.data.length > 0 ? response.data[0] : {}
                        })
                    }
                    if (!this.isConsultantOnly && this.investigation.undertakingId) {
                        undertakingService.get(this.$http, this.investigation.undertakingId).then(response => {
                            this.undertaking = response.data
                            return response
                        })
                    }
                    //load investigation migration refs
                    investigationService.listInvMigrationRefs(this.$http, this.investigation.investigationId).then(response => {
                        this.invMigrationRefs = response.data
                    })
                    //load PLSS
                    this.loadPlssLocationResultList()
                    // var searchDto = {investigationId: this.investigation.investigationId}
                    // culturalResourceRecordingService.search(this.$http, searchDto).then(response => {
                    //     if (response.data.length >= 0) {
                    //         this.siteCount = response.data.length
                    //     }
                    //     loggingService.log(this.isDebug, 'Investigation', `site count ${this.siteCount}`)
                    // })
                    //set site count
                    if (this.investigation.siteCount > 0) {
                        this.siteCount = this.investigation.siteCount
                    }
                    if (this.investigation.isolateCount > 0) {
                        this.isolateCount = this.investigation.isolateCount
                    }
                    if (this.$route.hash === '#siteSummary') {
                        this.activeTabIndex = this.tabsEnum.siteSummary
                    }
                    this.isLoading = false
                    return response
                })
            } else {
                loggingService.log(this.isDebug, 'Investigation', 'new investigation, loading project')
                return projectService.get(this.$http, this.$route.query.projectId).then(response => {
                    this.project = response.data
                    loggingService.log(this.isDebug, 'Investigation', 'loaded project')
                    if (this.investigation.investigationId || this.$route.params.investigationId) {
                        loggingService.log(this.isDebug, 'Investigation', 'Should load investigation')
                    } else {
                        this.createNewInvestigation()
                    }
                    this.isLoading = false
                    return response
                })
            }
        },
        createNewInvestigation () {
            this.investigation = {
                surveyScopeId: '',
                fieldworkStartDate: '',
                fieldworkEndDate: '',
                projectId: this.$route.query.projectId,
                isE106Investigation: !!this.$route.query.e106,
                crewCheifs: '',
                crewMembers: '',
                reportAuthor: '',
                reportDate: new Date(new Date().toLocaleDateString()),
                reportTitle: '',
                siteTypeId: -1
            }
        },
        submitInvestigation () {
            this.saving = true
            loggingService.log(this.isDebug, 'Investigation', 'submit investigation , validating')
            this.$validator.validateAll('investigation').then(result => {
                loggingService.log(this.isDebug, 'Investigation', 'done validating')
                if (result) {
                    loggingService.log(this.isDebug, 'Investigation', 'mapping activities')
                    var typeList = this.$refs['activitiesCheckboxPanel'].selectedList.map(x => {
                        return {
                            InvestigationTypeId: x,
                            InvestigationId: this.investigation.InvestigationId || 0
                        }
                    })
                    this.investigation.investigationTypeList = typeList

                    loggingService.log(this.isDebug, 'Investigation', 'submitting investigation')
                    investigationService.put(this.$http, this.investigation).then(response => {
                        var result = response.data
                        if (result.isValid) {
                            loggingService.log(this.isDebug, 'Investigation', 'investigation submitted, results valid')
                            this.serverErrorList = []
                            //this.investigation = result.objectList[0]
                            // if saving a new investigation, re-direct to correct route with investigationId after save
                            this.$router.push('/Investigation/' + response.data.objectList[0].investigationId)
                            this.loadData()
                            this.saving = false
                        } else {
                            loggingService.log(this.isDebug, 'Investigation', 'investigation submitted, server error')
                            this.serverErrorList = result.messages
                        }
                    })
                } else {
                    loggingService.log(this.isDebug, 'Investigation', 'submit - invalid form')
                    this.saving = false
                }
            })
        },
        saveBacklog () {
            loggingService.log(this.isDebug, 'Investigation', 'saveBacklog , validating')
            var investigationDto =
                {
                    investigationId: this.investigation.investigationId,
                    isBacklog: this.isBacklogSelect
                }
            investigationService.saveBacklog(this.$http, investigationDto).then(response => {
                var result = response.data
                if (result.isValid) {
                    loggingService.log(this.isDebug, 'Investigation', 'saveBacklog, results valid')
                    this.serverErrorList = []
                    this.loadData()
                } else {
                    loggingService.log(this.isDebug, 'Investigation', 'saveBacklog, server error')
                    this.serverErrorList = result.messages
                }
            })
        },
        loadPlssLocationResultList () {
            if (this.investigation.investigationId) {
                loggingService.log(this.isDebug, 'Investigation', 'loadPlssLocationResultList')
                investigationService.listInvestigationPlssLocationResultDto(this.$http, this.investigation.investigationId).then(response => {
                    this.plssLocationGridSpec.tableData = response.data
                })
            }
        },
        savePlss () {
            if (this.investigation.investigationId) {
                var plss = this.$refs['plssComponent'].plssData
                investigationService.putPlss(this.$http, this.investigation.investigationId, plss).then(response => {
                    loggingService.log(this.isDebug, 'Investigation', 'savePlss - complete')
                    this.loadPlssLocationResultList()
                    this.$refs['plssLocationModal'].close()
                })
            }
        },
        deletePlssLocation (investigationId) {
            loggingService.log(this.isDebug, 'Investigation', 'delete plss Location :' + investigationId)
            investigationService.deletePlssLocation(this.$http, investigationId).then(response => {
                this.loadPlssLocationResultList()
            })
        },
        addValues (list) {
            if (Array.isArray(list)) {
                var result = 0
                for (var i = 0; i < list.length; i++) {
                    result += isNaN(list[i]) ? 0 : list[i]
                }
                return Math.round(result * 10) / 10
            } else {
                return -1
            }
        },
        //trigger on workflow submit success
        workflowOnSubmitSuccess (validationResult) {
            //trigger media letter refresh if letter gen is triggered
            if (validationResult.letterGenTriggered && this.$refs.mediaLetter) {
                this.$refs.mediaLetter.autoRefreshMedia()
            }
            //reload page
            this.loadData()
        },
        genInvSummaryCoverReport () {
            this.reportLoading = true
            if (this.investigation.investigationId) {
                investigationService.investigationSummaryReportGen(this.$http, this.investigation.investigationId, [], false).then(response => {
                    mediaService.saveFileToDownload(response, 'InvgCoverReport.pdf')
                    this.reportLoading = false
                })
            } else {
                this.reportLoading = false
            }
        },
        genInvSummaryReport () {
            this.reportLoading = true
            if (this.investigation.investigationId) {
                if (this.$refs.siteSummary.culturalResourceList.length > 0) {
                    gisService.setGisServiceUrls(this.shpoUserDto.gisToken.token)
                    var siteList = this.$refs.siteSummary.culturalResourceList
                    var siteTrsPromises = []

                    siteList.forEach(site => {
                        //queue up gis query promise for each site
                        var trsDto = {
                            countyCode: site.countyCode,
                            siteNumber: site.siteNumber,
                            segment: site.segment
                        }
                        siteTrsPromises.push(this.querySiteTrs(site, trsDto))
                    })
                    //run promises
                    Promise.all(siteTrsPromises).then(results => {
                        //console.log(results)
                        investigationService.investigationSummaryReportGen(this.$http, this.investigation.investigationId, results, true).then(response => {
                            mediaService.saveFileToDownload(response, 'InvSummaryReport.pdf')
                            this.reportLoading = false
                        })
                    })
                } else {
                    investigationService.investigationSummaryReportGen(this.$http, this.investigation.investigationId, [], true).then(response => {
                        mediaService.saveFileToDownload(response, 'InvSummaryReport.pdf')
                        this.reportLoading = false
                    })
                }
            } else {
                this.reportLoading = false
            }
        },
        querySiteTrs (site, trsDto) {
            return new Promise((resolve, reject) => {
                gisService.siteToTrsQuery(trsDto).then(result => {
                    resolve(
                        {
                            culturalResourceId: site.culturalResourceId,
                            trsList: result.join(', ')
                        }
                    )
                })
            })
        },
        handleMediaRefreshComplete () {
            this.loadPlssLocationResultList()
        }
    }
}
</script>



// WEBPACK FOOTER //
// Investigation.vue?474a2c37